"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * 导出进度管理混入
 * 为导出功能添加美观的进度条显示
 */
var _default = exports.default = {
  data: function data() {
    return {
      exportProgress: {
        visible: false,
        title: '导出数据',
        percentage: 0,
        statusText: '准备导出...',
        isError: false,
        isSuccess: false,
        canCancel: true,
        fileName: '',
        fileSize: '',
        estimatedTime: '',
        currentTask: null
      }
    };
  },
  methods: {
    /**
     * 开始导出并显示进度
     * @param {Function} exportFn - 导出函数
     * @param {Object} options - 配置选项
     */
    startExportWithProgress: function () {
      var _startExportWithProgress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(exportFn) {
        var _this = this;
        var options,
          _options$title,
          title,
          _options$fileName,
          fileName,
          _options$estimatedDur,
          estimatedDuration,
          onSuccess,
          onError,
          onCancel,
          isCancelled,
          progressInterval,
          result,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _options$title = options.title, title = _options$title === void 0 ? '导出数据' : _options$title, _options$fileName = options.fileName, fileName = _options$fileName === void 0 ? '数据导出' : _options$fileName, _options$estimatedDur = options.estimatedDuration, estimatedDuration = _options$estimatedDur === void 0 ? 5000 : _options$estimatedDur, onSuccess = options.onSuccess, onError = options.onError, onCancel = options.onCancel; // 显示进度对话框
              this.showExportProgress(title, fileName);

              // 创建可取消的任务
              isCancelled = false;
              this.exportProgress.currentTask = {
                cancel: function cancel() {
                  isCancelled = true;
                  onCancel && onCancel();
                }
              };
              _context.p = 1;
              // 启动进度模拟
              progressInterval = this.simulateExportProgress(estimatedDuration, function () {
                return isCancelled;
              }); // 执行导出
              _context.n = 2;
              return exportFn();
            case 2:
              result = _context.v;
              // 清除进度模拟
              clearInterval(progressInterval);
              if (!isCancelled) {
                _context.n = 3;
                break;
              }
              this.hideExportProgress();
              this.$message.warning('导出已取消');
              return _context.a(2);
            case 3:
              // 导出成功
              this.exportProgress.percentage = 100.00;
              this.exportProgress.statusText = '导出完成！';
              this.exportProgress.isSuccess = true;
              this.exportProgress.canCancel = false;

              // 处理结果
              if (result && result.fileName) {
                // 如果返回文件名，自动下载
                window.open(result.fileName);
              }

              // 延迟关闭
              setTimeout(function () {
                _this.hideExportProgress();
                _this.$message.success('导出完成！');
                onSuccess && onSuccess(result);
              }, 1500);
              _context.n = 6;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              if (!isCancelled) {
                _context.n = 5;
                break;
              }
              this.hideExportProgress();
              return _context.a(2);
            case 5:
              // 导出失败
              this.exportProgress.isError = true;
              this.exportProgress.statusText = '导出失败：' + (_t.message || '未知错误');
              this.exportProgress.canCancel = false;
              this.$message.error('导出失败：' + (_t.message || '未知错误'));
              onError && onError(_t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4]]);
      }));
      function startExportWithProgress(_x) {
        return _startExportWithProgress.apply(this, arguments);
      }
      return startExportWithProgress;
    }(),
    /**
     * 显示导出进度对话框
     */
    showExportProgress: function showExportProgress(title, fileName) {
      this.exportProgress = {
        visible: true,
        title: title,
        percentage: 0,
        statusText: '准备导出...',
        isError: false,
        isSuccess: false,
        canCancel: true,
        fileName: fileName,
        fileSize: '',
        estimatedTime: '',
        currentTask: null
      };
    },
    /**
     * 隐藏导出进度对话框
     */
    hideExportProgress: function hideExportProgress() {
      this.exportProgress.visible = false;
      this.exportProgress.currentTask = null;
    },
    /**
     * 模拟导出进度
     */
    simulateExportProgress: function simulateExportProgress(duration, shouldStop) {
      var _this2 = this;
      var startTime = Date.now();
      var stages = [{
        progress: 20,
        text: '正在查询数据...'
      }, {
        progress: 40,
        text: '正在处理数据...'
      }, {
        progress: 60,
        text: '正在生成文件...'
      }, {
        progress: 80,
        text: '正在准备下载...'
      }, {
        progress: 95,
        text: '即将完成...'
      }];
      var currentStage = 0;
      var interval = setInterval(function () {
        if (shouldStop()) {
          clearInterval(interval);
          return;
        }
        var elapsed = Date.now() - startTime;
        var progress = Math.min(elapsed / duration * 95, 95); // 最大95%，留给实际完成

        _this2.exportProgress.percentage = Math.round(progress);

        // 更新状态文本
        var targetStage = stages.find(function (stage) {
          return progress < stage.progress;
        });
        if (targetStage && currentStage < stages.indexOf(targetStage)) {
          currentStage = stages.indexOf(targetStage);
          _this2.exportProgress.statusText = targetStage.text;
        }

        // 更新预估时间
        if (progress > 10) {
          var remainingTime = Math.max(0, (duration - elapsed) / 1000);
          _this2.exportProgress.estimatedTime = _this2.formatTime(remainingTime);
        }

        // 当达到95%时停止模拟，等待实际完成
        if (progress >= 95) {
          clearInterval(interval);
        }
      }, 100);
      return interval;
    },
    /**
     * 取消导出
     */
    handleExportCancel: function handleExportCancel() {
      if (this.exportProgress.currentTask && this.exportProgress.currentTask.cancel) {
        this.exportProgress.currentTask.cancel();
      }
      this.hideExportProgress();
    },
    /**
     * 重试导出
     */
    handleExportRetry: function handleExportRetry() {
      // 这里应该重新执行导出操作
      // 具体实现依赖于调用方
      this.$emit('export-retry');
    },
    /**
     * 导出完成
     */
    handleExportComplete: function handleExportComplete() {
      this.hideExportProgress();
    },
    /**
     * 格式化时间
     */
    formatTime: function formatTime(seconds) {
      if (seconds < 1) return '即将完成';
      if (seconds < 60) return "\u7EA6 ".concat(Math.round(seconds), " \u79D2");
      if (seconds < 3600) return "\u7EA6 ".concat(Math.round(seconds / 60), " \u5206\u949F");
      return "\u7EA6 ".concat(Math.round(seconds / 3600), " \u5C0F\u65F6");
    }
  }
};